import { getToken } from "../store/authStore";

export interface ILazyParams {
  first: number;
  rows: number;
  page: number;
  sortField: string;
  sortOrder?: 1 | 0 | -1 | undefined | null;
}

export const baseUrl = "https://ats-business-stg-api.teklense.com/api/";

export async function Fetch<T = any>(
  url: string,
  options?: {
    method?: "GET" | "POST" | "PUT" | "DELETE";
    body?: any;
    query?: string;
    isFormData?: boolean;
    onError?: (msg: string) => void;
  }
): Promise<T | null> {
  const {
    method = "GET",
    body,
    query,
    isFormData = false,
  } = options || {};

  const headers: HeadersInit = {};

  const token = getToken();
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  if (!isFormData) {
    headers["Content-Type"] = "application/json";
  }

  try {
    const res = await fetch(
      `${baseUrl}${url}${query ? `?${query}` : ""}`,
      {
        method,
        headers,
        body: body
          ? isFormData
            ? body
            : JSON.stringify(body)
          : undefined,
      }
    );

    if (res.status === 401) {
      sessionStorage.clear();
      return null;
    }

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      const message = err.message || "Something went wrong";
      options?.onError?.(message);
      throw new Error(message);
    }

    return await res.json();
  } catch (err) {
    console.error("API Error:", err);
    return null;
  }
}